module.exports = __webpack_public_path__ + "img/129.da263129.png";